<template>
  <el-form-item
    :label="label"
    :prop="prop"
  >
    <div class="jin-pc">
      <el-date-picker
        v-if="isRang"
        style="width: 320px;"
        :value="value"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @input="onChange"
      />
      <el-date-picker
        v-else
        :value="value"
        style="width: 320px;"
        type="month"
        placeholder="请选择"
        @input="onChange"
      />
    </div>
    <div class="jin-m">
      <div v-if="isRang" class="jin-m-date">
        <!-- {{ value }} -->
        <div @click="show = true, i = 1">
          <el-input :value="value[0] ? dayjs(value[0]).format('YYYY/MM') : ''" readonly placeholder="开始年月" />
        </div>
        <div @click="show = true, i = 2">
          <el-input :value="value[1] ? dayjs(value[1]).format('YYYY/MM') : ''" readonly placeholder="结束年月" />
        </div>
      </div>
      <div v-else @click="show = true">
        <el-input :value="value" readonly placeholder="开始年月" />
      </div>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="onConfirm"
      />
    </van-popup>
  </el-form-item>
</template>

<script>
import { DatetimePicker, Popup } from 'vant'
export default {
  components: {
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: ''
    },
    value: {
      type: [Array, Date, String],
      default: () => ''
    },
    isRang: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      date: '',
      time: [],
      i: 0,
      show: false,
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      currentDate: new Date()
    }
  },
  watch: {
    value: {
      handler(n) {
        if (!Array.isArray(n)) this.date = n
      },
      deep: true
    }
  },
  methods: {
    onConfirm(v) {
      if (this.i) {
        this.time[this.i - 1] = this.dayjs(v).format('YYYY/MM')
        this.$emit('input', this.time)
      } else {
        this.$emit('input', this.dayjs(v).format('YYYY/MM'))
      }

      this.show = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    onChange(v) {
      let date
      if (Array.isArray(v)) {
        date = v.length ? [this.dayjs(v[0]).format('YYYY/MM'), this.dayjs(v[1]).format('YYYY/MM')] : v
      } else {
        date = this.dayjs(v).format('YYYY/MM')
      }
      this.$emit('input', date || [])
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-m {
    &-date {
      width: 100%;
      display: flex;

      > div {
        position: relative;
        flex: 1;

        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          right: 9px;
          margin-top: -3px;
          width: 0;
          border: 6px solid #979797;
          border-color: #979797 transparent transparent transparent;
        }

        &:nth-of-type(1) {
          margin-right: 9px;
        }
      }
    }
  }
}
</style>
